import { Notice } from '@genial/components';
import { Utils } from '@genial/utils';
import React from 'react';

import { useRecoilQuery } from '../../../../hooks/useRecoilQuery';
import { IInvestedAssetsNormalized } from '../../../../store/customerDetail/types';
import { productMarketStatusSelector } from '../../../../store/product/selector';
import { ProductWithMarketStatus } from '../../../../store/product/types';

export namespace ClosedMarketIndicatorTypes {
  export interface Props {
    product: IInvestedAssetsNormalized;
  }
}

const validIndicators = {
  '3': ProductWithMarketStatus.FixedIncome,
  '4': ProductWithMarketStatus.Equity,
  '6': ProductWithMarketStatus.TreasuryDirect,
  '7': ProductWithMarketStatus.COES,
};

export const ClosedMarketIndicator: React.FC<ClosedMarketIndicatorTypes.Props> = ({ product }) => {
  const { data } = useRecoilQuery(
    productMarketStatusSelector({ product: validIndicators[product.marketTypeNormalized] }),
    {
      if: () => !!validIndicators[product.marketTypeNormalized],
    }
  );

  if (data && !data.isOpen) {
    return (
      <Notice
        testId="notice-closed-market"
        type="warning"
        backgroundColor={Utils.ColorToken.WithOpacity(
          'feedback.attention.lightest',
          'opacity.medium'
        )}
        textObjects={[{ text: 'Mercado fechado para resgate', variant: 'regular' }]}
      />
    );
  }

  return null;
};
